<template>
  <VCard
    v-if="breadcrumbItems.length>0"
    class="py-1"
  >
    <VBreadcrumbs :items="breadcrumbItems">
      <template #divider>
        <VIcon icon="tabler-chevron-right" />
      </template>
      
      <template #title="{item}">
        <template v-if="item.link">
          <NuxtLink
            :key="item.order"
            :to="item.link"
          >
            <VIcon
              v-if="item.icon"
              :icon="item.icon"
              size="12"
            />

            <template v-else>
              {{ item.label }}
            </template>
          </NuxtLink>
        </template>
        <template v-else>
          <VBtn
            :key="item.order"
            color="primary"
            variant="tonal"
            size="small"
            @click="execute(item)"
          >
            <VIcon
              v-if="item.icon"
              :icon="item.icon"
              size="12"
            />
            <template v-else>
              {{ item.label }}
            </template>
          </VBtn>
        </template>
      </template>
    </VBreadcrumbs>
  </VCard>
</template>

<script setup>
import { useGeneralStore } from '@/store/GeneralStore'

const { unsetBread } = useGeneralStore()
const { breadItems } = storeToRefs(useGeneralStore())

const breadcrumbItems = computed(() =>breadItems.value)

const execute = item => {
  unsetBread(item.order)
  if (item.action) {
    item.action()
  }
}
</script>
